import { Col, FormGroup, Input, Label, Row } from '@polichat/flamboyant';
import { useState } from 'react';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';
import {
  LabelWithSpan,
  OptionsContainer,
} from '../../FormMessagesBuilder.styles';

function CreateButtonList({ onUpdate, initialValue, isEdit }) {
  const [buttonData, setButtonData] = useState(initialValue);

  // Traduções
  const buttonLabel = useGlotaT('spa.messageBuilder.list.button.label');
  const buttonDescription = useGlotaT('spa.messageBuilder.list.button.description');
  const buttonPlaceholder = useGlotaT('spa.messageBuilder.list.button.placeholder');

  const handleInputChange = ({ target: { name, value } }) => {
    setButtonData({
      ...buttonData,
      [name]: value,
    });
    handleButtonData({
      ...buttonData,
      [name]: value,
    });
  };

  const handleButtonData = (data) => {
    onUpdate(data);
  };

  return (
    <Row>
      <Col sm={12}>
        <FormGroup>
          <LabelWithSpan>
            <Label>
              {buttonLabel}:{'  '}
              <span>
                {buttonDescription}{' '}
              </span>
            </Label>
          </LabelWithSpan>
          <Input
            type="text"
            id="button-message"
            name="text"
            placeholder={buttonPlaceholder}
            value={buttonData.text}
            onChange={handleInputChange}
            showCharCounter
            maxLength={20}
            disabled={isEdit}
            required
          />
          <OptionsContainer></OptionsContainer>
        </FormGroup>
      </Col>
    </Row>
  );
}

export default CreateButtonList;
